import React, { createContext, useContext, useState, useCallback } from "react";

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("ro");
  const t = useCallback((obj) => (obj && obj[lang] != null ? obj[lang] : ""), [lang]);
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};

export const COMPANY = {
  name: "HEB TEAM TRANS",
  legal: "HEB TEAM TRANS SRL",
  person: "Emanuel Hodoroaba",
  slogan: { ro: "Moving Forward Together.", en: "Moving Forward Together." },
  location: { ro: "Dumbrăveni, Nr. 1861, Județ Suceava, Cod Poștal 727225", en: "Dumbrăveni, No. 1861, Suceava County, Postal Code 727225" },
  phone: "+40 747 344 701",
  phoneRaw: "+40747344701",
  phoneOffice: "+40 330 802 308",
  phoneOfficeRaw: "+40330802308",
  email: "contact@hebteamtrans.com",
  whatsapp: "40747344701",
  logo: "/logo.webp",
};

export const PARTNERS = [
  { name: "amazon", label: "amazon", img: "/amazon.webp" },
  { name: "DHL", label: "DHL", img: "/dhl.webp" },
  { name: "DKV", label: "DKV", img: "/dkv.webp" },
  { name: "Shell", label: "Shell", img: "/shell.webp" },
  { name: "MAN", label: "MAN", img: "/man.webp" },
  { name: "Scania", label: "SCANIA", img: "/scania.webp" },
  { name: "Volvo", label: "Volvo", img: "/volvo.webp" },
];

export const logoUrl = (domain) => `https://logo.clearbit.com/${domain}?size=200`;

/* Brand logo images for trailer/truck manufacturers */
export const BRAND_IMAGES = {
  MAN: "/man.webp",
  Scania: "/scania.webp",
  Volvo: "/volvo.webp",
  Schmitz: "/schmitz.webp",
  "Kögel": "/kogel.webp",
  Krone: "/krone.webp",
};

export const MAIN_IMAGE = "/poza3-seo.webp";

export const GALLERY = [
  { url: "/poza3.webp", ro: "Flota HEB Team Trans", en: "The HEB Team Trans fleet" },
  { url: "/poza2.webp", ro: "Scania", en: "Scania — the power of our fleet" },
  { url: "/poza1.webp", ro: "Livrare la punct de lucru", en: "Delivery at destination" },
  { url: "/poza4.webp", ro: "Transport agabaritic", en: "Heavy machinery transport" },
  { url: "/poza5.webp", ro: "Transport de noapte", en: "Night haulage" },
  { url: "/poza6.webp", ro: "Pe drum, non-stop", en: "On the road, non-stop" },
  { url: "/poza12.webp", ro: "Flotă în mișcare", en: "Fleet on the move" },
  { url: "/poza13.webp", ro: "Pregătiți de drum", en: "Ready for the road" },
  { url: "/poza14.webp", ro: "Livrare în siguranță", en: "Safe delivery" },
  { url: "/poza15.webp", ro: "Echipaj profesionist", en: "Professional crew" },
  { url: "/poza16.webp", ro: "Livrare pentru Amazon", en: "Amazon delivery" },
  { url: "/poza17.webp", ro: "Flota HEB Team Trans", en: "The HEB Team Trans fleet" },
];
